<template>

<div class="overlay2"> 
    <div class="overlay back"> 
    </div>
    <div class="masthead">
        <div class="masthead-bg"></div>
        <div class="container h-100">
            <div class="row h-100">
                <div class="col-12 my-auto">
                    <div class="masthead-content text-white py-5 py-md-0">
                        <h2 class="mb-3">
                            <font style="vertical-align: inherit;">
                                <font style="vertical-align: inherit;">
                                    Sistema Ventana Unica TGR
                                </font>
                            </font>
                        </h2>
                        <a href="/home" class="botonServel">
                            <font style="vertical-align: inherit;">
                                <font style="vertical-align: inherit;">Ingresa con ID Servel</font>
                            </font>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="social-icons">
        <img src="/img/logo.png" style="max-height:100px">
    </div>

</div>
  
</template>

<script>  
import auth from '../service/auth'   

export default { 

      mounted() {
        // eliminar todo de local storage 
        localStorage.clear()

        console.log("storage borrado 2.0")

        let style = document.createElement('link');
        style.type = "text/css";
        style.rel = "stylesheet";
        style.href = '/css/coming-soon.css';
        // style.href = 'https://gestordocumental.servel.cl/public/stylesheets/coming-soon.css';
        document.body.appendChild(style);
    }
  }
</script>
<style > 

.back {
    background-image:url(/img/backgroud.jpg);
    background-size: cover;
}

.overlay2 {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%; 
    z-index: 1;
} 

</style>
